import React, { ReactNode } from 'react';
import { Field } from 'react-final-form';
import { MediaData } from '~admin/model/media-data';
import { MediaInput } from '~admin/view/components/ui/form/fields/media/media-input.component';
import { MediaType } from '~client/model/media-type';

interface Props {
  name: string;
  label: string;
  mediaType: MediaType;
  onMediaSelected?: (media: MediaData | null) => void;
  disabled?: boolean;
  submitFailed?: boolean;
}

export const MediaField: React.FunctionComponent<Props> = ({
  name,
  label,
  mediaType,
  onMediaSelected,
  disabled,
  submitFailed,
  ...rest
}) => {
  return (
    <Field
      label={label}
      name={name}
      render={(renderProps): ReactNode => (
        <MediaInput
          label={label}
          mediaType={mediaType}
          onMediaSelected={onMediaSelected}
          disabled={disabled}
          submitFailed={submitFailed}
          {...renderProps}
        />
      )}
      {...rest}
    />
  );
};



// WEBPACK FOOTER //
// ./view/components/ui/form/fields/field-media.component.tsx